// extracted by mini-css-extract-plugin
export var column = "K_cc";
export var container = "K_h";
export var icon = "K_bw";
export var link = "K_bt";
export var title = "K_d";